import React from 'react';
import { Paper, Typography, Divider, Grid } from "@mui/material";

const LabOrderOverview = ({ order }) => {
  if (!order) {
    return <div>No order data available.</div>;
  }

  return (
    <Paper elevation={3} sx={{ padding: 3 , marginTop:3 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Sub Order: {order.subOrder}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Project Number: {order.projectNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Client Name: {order.clientName}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Account Number: {order.accountNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Order Pay Type: {order.orderPayType}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Client Code: {order.clientCode}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Po Number: {order.poNumber}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Project Description: {order.projectCategory}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Special Instructions: {order.specialInstructions}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Billing Code: {order.billingCode}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Status: {order.status}
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Hold: {order.hold ? 'Yes' : 'No'}
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Will Rush Pay: {order.willRushPay ? 'Yes' : 'No'}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
          Company Name: {order.companyName }
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Typography variant="body1" sx={{ mb: 1 }}>
          Priority: {order.priority }
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" sx={{ mb: 1, whiteSpace: "pre-wrap" }}>
            Internal Comments: {order.internalComments}
          </Typography>
        </Grid>
        {/* Continue adding properties in a similar grid layout */}
        {/* ... Add all remaining properties here */}
      </Grid>

    </Paper>
  );
};

export default LabOrderOverview;
